export const getProgressDefault = () => ({
  finish: 0,
  inProgress: 0,
  pending: 0,
})

export const formatPercentage = (val: number, total: number) =>
  +((val / total) * 100).toFixed(1)

interface Progress {
  finish: number
  inProgress: number
  pending: number
}

export function reduceProgress<P extends Progress>(
  coursesProgress: P[]
): Progress {
  return (coursesProgress || []).reduce((acc, val) => {
    acc.finish += val.finish
    acc.inProgress += val.inProgress
    acc.pending += val.pending
    return acc
  }, getProgressDefault())
}

export function getProgressPercentage<P extends Progress>(
  coursesProgress: P[]
): Progress {
  const { finish, inProgress, pending } = reduceProgress(coursesProgress)

  const totalPercent = finish + inProgress + pending || 1
  const format = (percent: number) => formatPercentage(percent, totalPercent)
  return {
    finish: format(finish),
    inProgress: format(inProgress),
    pending: format(pending),
  }
}
